import React from 'react';
import { Box, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useAreaRatingExtremes } from 'store/apis';
import { RatingExtremesOverview } from './rating-extremes';
import { MINIMUM_REQUIRED_EXTREMES } from 'consts/dashboard.const';

interface ChartAreaRatingExtremesProps {
  buildingId: number;
  start: string;
  end: string;
}

export const ChartAreaRatingExtremes = ({ buildingId, start, end }: ChartAreaRatingExtremesProps) => {
  const { data = { top: [], bottom: [] }, isFetching } = useAreaRatingExtremes({ buildingId, start, end });

  return (
    <DashboardMetricCardWrapper
      title="Highest/Lowest Rated Zone Areas"
      loading={isFetching}
      loadingText="Loading zone areas..."
    >
      {data.top.length < MINIMUM_REQUIRED_EXTREMES && data.bottom.length < MINIMUM_REQUIRED_EXTREMES && (
        <Box sx={{ textAlign: 'center' }}>
          <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />

          <Typography color="primary" sx={{ marginTop: 2 }}>
            Not Enough Rated Area Info
          </Typography>
        </Box>
      )}

      {data.top.length >= MINIMUM_REQUIRED_EXTREMES || data.bottom.length >= MINIMUM_REQUIRED_EXTREMES ? (
        <RatingExtremesOverview topExtreme={data.top} bottomExtreme={data.bottom} />
      ) : null}
    </DashboardMetricCardWrapper>
  );
};
